export default __webpack_public_path__ + "static/media/recent-activity-artwork-4.b6a7d8de.png";